<template>
    <div style="text-align: center;">
        <img :src="require('@/assets/images/report-1.jpg')" style="width:1190px"/>                
    </div>
    <div style="text-align: center;">
        <img :src="require('@/assets/images/report-2.jpg')" style="width:1190px"/>                
    </div>
    <div style="text-align: center;">
        <img :src="require('@/assets/images/report-3.jpg')" style="width:1190px"/>                
    </div>
</template>
  
<script setup>
    import { onMounted } from 'vue'  

    onMounted(() => {
        
    });
</script>